import Vue from "vue";
import moment from "moment";
import ApiService from "../../../../../services/api";
import gridbase from "../../../../../components/gridComponentBase.js";
import { bus } from "../../../../../main";
import { mapGetters } from "vuex";

export default {
	extends: gridbase,
	props: {
		filters: Array
	},
	data: function() {
		return {
			columns: [
				{
					field: "number_plate",
					title: "targa",
					configId: "numberPlate",
					width: "100",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				},
				{
					field: "vehicle_code",
					title: "codice",
					configId: "vehicleCode",
					width: "130",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				},
				{
					field: "brand_name",
					title: "marca",
					configId: "brandName",
					width: "150",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				},
				{
					field: "vehicle_name",
					title: "veicolo",
					configId: "vehicleName",
					width: "205",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				},
				{
					field: "division_name",
					title: "divisione",
					configId: "divisionName",
					width: "150",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					permit: "hasDivisions",
					sortable: false
				},
				{
					field: "first_start_date",
					title: "prima data partenza",
					configId: "firstStartDate",
					width: "240",
					headerCell: "myHeaderTemplate",
					format: "datetime",
					cell: "myCellTemplate",
					filterable: false,
					sortable: false
				},
				{
					field: "last_end_date",
					title: "ult. data arrivo",
					configId: "lastStartDate",
					width: "240",
					headerCell: "myHeaderTemplate",
					format: "datetime",
					cell: "myCellTemplate",
					filterable: false,
					sortable: false
				},
				{
					field: "total_gps_km",
					title: "km gps",
					configId: "totalGpsKm",
					width: "250",
					format: "numeric",
					cell: "myCellTemplate",
					headerCell: "myHeaderTemplate",
					filterable: false,
					sortable: false
				},
				{
					field: "total_path_km",
					title: "km path",
					configId: "totalPathKm",
					width: "200",
					headerCell: "myHeaderTemplate",
					format: "numeric",
					cell: "myCellTemplate",
					filterable: false,
					tag: "no_valid_path_km",
					sortable: false
				},
				{
					field: "total_interpolated_km",
					title: "km interpolati",
					configId: "totalInterpolatedKm",
					width: "210",
					headerCell: "myHeaderTemplate",
					format: "numeric",
					cell: "myCellTemplate",
					filterable: false,
					tag: "no_valid_interpolated_km",
					sortable: false
				},
				{
					field: "avg_speed",
					title: "veloc. media",
					configId: "avgSpeed",
					width: "210",
					headerCell: "myHeaderTemplate",
					format: "numeric",
					cell: "myCellTemplate",
					filterable: false,
					tag: "no_positions",
					sortable: false
				},
				{
					field: "total_co2",
					title: "CO2 totale",
					configId: "totalCo2",
					width: "210",
					headerCell: "myHeaderTemplate",
					format: "numeric",
					cell: "myCellTemplate",
					filterable: false,
					tag: "no_valid_lt",
					sortable: false
				},
				{
					field: "avg_consumption_lt_hkm",
					title: "CONSUMO medio (DV)",
					configId: "avgFuelConsumption",
					width: "230",
					headerCell: "myHeaderTemplate",
					format: "numeric",
					cell: "myCellTemplate",
					filterable: false,
					tag: "no_valid_lt",
					sortable: false
				},
				{
					field: "brand_fuel_consumption",
					title: "CONSUMO medio costruttore",
					configId: "brandFuelConsumption",
					width: "280",
					headerCell: "myHeaderTemplate",
					format: "numeric",
					cell: "myCellTemplate",
					filterable: false,
					sortable: false
				},
				{
					field: "avg_consumption_km_lt",
					title: "consumo km/lt",
					configId: "fuelConsumptionKmLt",
					width: "260",
					headerCell: "myHeaderTemplate",
					format: "numeric",
					cell: "myCellTemplate",
					filterable: false,
					tag: "no_valid_lt",
					sortable: false
				},
				{
					field: "total_lt",
					title: "litri totali",
					configId: "totalLt",
					width: "230",
					headerCell: "myHeaderTemplate",
					format: "numeric",
					cell: "myCellTemplate",
					filterable: false,
					tag: "no_valid_lt",
					sortable: false
				},
				{
					field: "brand_total_lt",
					title: "litri totali costruttore",
					configId: "brandTotalLt",
					width: "260",
					headerCell: "myHeaderTemplate",
					format: "numeric",
					cell: "myCellTemplate",
					filterable: false,
					sortable: false
				}
			],

			config: [],
			columnsToShow: [],

			vehicleIdFilterField: "number_plate",
			vehicleIdFilterFieldFormatted: "vehicles",
			hasDivisions: false
		};
	},

	created() {
		this.hasSelectedMode = true;
		this.vehicleIdFilterField = this.settings.vehicleIdFilterField;
		this.vehicleIdFilterFieldFormatted = "vehicles";
		if (this.vehicleIdFilterField == "code") {
			this.vehicleIdFilterFieldFormatted = "vehicleCodes";
		}
		if (this.settings && this.settings.hasDivisions) this.hasDivisions = true;	
	},
	mounted() {
		this.getConfig();
	},
	watch: {
		// filters: {
		// 	handler: function() {
		// 		this.getData();
		// 	},
		// 	deep: true
		// }
	},
	methods: {
		applyReportFilter() {
			this.skip = 0;
			this.query.page = 0;
			this.getData();
		},
		sortChangeHandler: function(e) {
			this.sort = e.sort;
			this.getData();
		},
		pageChangeHandler: function(event) {
			this.skip = event.page.skip;
			this.take = event.page.take;

			if (this.skip === 0) {
				this.query.page = 0;
			}
			this.query.page = this.skip / this.take;

			this.getData();
		},
		getConfig: function() {
			var self = this;
			ApiService.getViewConfig("fleerun_report_journey_synthetic")
				.then(res => {
					self.config = res;
					self.setConfigColumns();
				})
				.finally(res => {
					self.getData();
				});
		},
		downloadXlsx: function(type) {
			var self = this;
			var data = this.getRequestData();
			if (type == 'csv') data['format'] = 'csv';
			ApiService.exportXlsx("report/journey/synthetic", data).then(res => {
				let blob = self.$options.filters.b64toBlob(res.data.fileContents);
				let link = document.createElement("a");
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", res.data.fileDownloadName || `Report_Percorrenza_sintetico.${type}`);
				link.style = "visibility:hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			});
		},
		getData: function() {
			var self = this;

			this.$emit("on-loading", true);

			var data = this.getRequestData();

			ApiService.getJourneySyntheticPaged(data).then(res => {
				self.items = res.items.map(function(item) {
					var row = {};
					self.columns.forEach(function(c) {
						if (c.tag && item.tags && item.tags.some(tag => {return tag == c.tag;})) {
							row[c.field] = "(*)"
						} else {
							row[c.field] = item[c.field];
						}
					});
					return row;
				});

				self.total = res.totalCount;

				self.$emit("on-loading", false);
			});
		},
		getRequestData() {
			var self = this;
			var data = this._.clone(this.query);

			// if (this.columnFilters) {
			// 	for (var i = 0; i < this.columnFilters.length; i++) {
			// 		var clmF = this.columnFilters[i];

			// 		for (var j = 0; j < clmF.filter.filters.length; j++) {
			// 			var filt = clmF.filter.filters[j];
			// 			var field = filt.field;
			// 			var value = filt.value;

			// 			data[field] = value;
			// 		}
			// 	}
			// }

			if (this.filters && this.filters.length > 0) {
				this.filters.forEach(element => {
					switch (element.id) {
						case "timerange":
							data["dateRange.From"] = moment(element.value.startRange)
								.utc()
								.format();
							data["dateRange.To"] = moment(element.value.endRange)
								.utc()
								.format();
							break;
						case "divisions":
							if (element.value) {
								data["division"] = element.value;
							}
							break;
						case "groups":
							if (element.value && element.value != -1) {
								data["group"] = element.value;
							}
							break;
						case "vehicles":
							if (element.value && element.value.length > 0) {
								for (var j = 0; j < element.value.length; j++) {
									var field = `${self.vehicleIdFilterFieldFormatted}[${j}]`;
									var value = element.value[j];

									data[field] = value;
								}
							}
							break;
						case "drivers":
							if (element.value) {
								data["driver"] = element.value;
							}
							break;

						default:
							break;
					}
				});
			}

			return data;
		},
		setConfigColumns() {
			var self = this;
			if (self.config && self.config.length > 0) {
				var orderedConfigColumn = self._.orderBy(self.config, "order", "asc");

				orderedConfigColumn.forEach(column => {
					var defColumn = self.columns.find(function(f) {
						return f.configId === column.field;
					});

					if (defColumn && column.enabled && (!defColumn.permit || self[defColumn.permit])) {
						defColumn.title = column.label;

						self.columnsToShow.push(defColumn);
					}
				});

				if (self.columnsToShow.length > 0) {
					var columnsByPassConfig = self._.filter(self.columns, function(item) {
						return item.configByPass;
					});

					for (var i = 0; i < columnsByPassConfig.length; i++) {
						self.columnsToShow.push(columnsByPassConfig[i]);
					}
				}

				self.dataReady = true;
			}
		},
		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		}
	},
	computed: {
		...mapGetters(["settings"]),
	}
};
